<template>
  <div>
    <canvas :id="id" :height="height" class="ct-chart" v-scrollable="scrollable"></canvas>
  </div>
</template>

<script>
import BaseChart from './BaseChart.vue'
import { colors } from './colors.js'
import tinycolor from 'tinycolor2'

// This class is responsible to extract, transform and load data
// from Wavycat API to ChartJS API
class EtlStackedBarData {
  constructor(wavycatData) {
    this.wavycatData = wavycatData
    this.dataReady = {
      datasets: [],
      labels: [],
    }
  }

  processObjectiveArea(data, index) {
    if (!index) {
      // this is the style of the objective area
      this.dataReady.datasets.push({
        type: 'line',
        label: 'target',
        fill: false,
        pointRadius: 2,
        borderWidth: 2,
        borderColor: colors.target,
        data: [],
      })
    }

    this.dataReady.datasets[0].data.push(data.target.value)
  }

  processLabels(data) {
    if (!data.data_offset) this.dataReady.labels.push(data.label)
  }

  processBars(data, index) {
    Object.keys(data.bars).forEach((barKey) => {
      var barData = this.getBar(barKey, data)
      if (!barData) {
        barData = new BarDataset(barKey, data, this.wavycatData.options)
        this.dataReady.datasets.push(barData)
      }
      barData.data.push(data.bars[barKey].value)
    })
  }

  getBar(key, barData) {
    return this.dataReady.datasets.find((d) => d.label == key && d.stack == barData.data_offset)
  }

  process() {
    this.wavycatData.datasets.forEach((data, index) => {
      this.processLabels(data)
      this.processObjectiveArea(data, index)
      this.processBars(data, index)
    })

    return this
  }

  getData() {
    return this.dataReady
  }
}

class BarDataset {
  // private
  barStyles = {
    target: {
      type: 'line',
      fill: false,
      pointRadius: 0,
      borderWidth: 0,
    },
    groups: {
      backgroundColor: colors.groups,
    },
    online: {
      backgroundColor: colors.online,
    },
    direct: {
      backgroundColor: colors.direct,
    },
    ttoo: {
      backgroundColor: colors.ttoo,
    },
  }

  constructor(barKey, data, options) {
    var bar = Object.assign(this.barStyles[barKey], {
      label: barKey,
      stack: String(data.data_offset),
      data: [],
      order: options[barKey].order * 10 + 10,
    })

    if (bar.stack == '0') {
      bar.backgroundColor = new tinycolor(bar.backgroundColor).darken().toHexString()
      bar.borderColor = '#000'
      bar.borderWidth = 1
    } else {
      bar.backgroundColor = new tinycolor(bar.backgroundColor).lighten().toHexString()
      bar.order -= 5
    }

    return bar
  }
}

export default {
  mixins: [BaseChart],
  computed: {
    dataReady() {
      var etl = new EtlStackedBarData(this.data)
      var data = etl.process().getData()

      return data
    },
    optionsReady(vm) {
      return Object.assign(vm.options, {
        tooltips: {
          enabled: true,
          mode: 'index',
          titleFontSize: 14,
          bodyFontSize: 14,
          bodySpacing: 6,
          xPadding: 8,
          yPadding: 8,
          //yAlign: "bottom",
          callbacks: {
            label: (tooltipItem, data) => {
              var dataset = data.datasets[tooltipItem.datasetIndex]
              var label = dataset.label
              if (Number(dataset.stack)) label += ' (' + Number(dataset.stack) * -1 + ') '

              return label + ': ' + Number(tooltipItem.value).toFixed(2) + '%'
            },
          },
        },
        scales: {
          yAxes: [
            {
              type: 'linear',
              ticks: {
                min: vm.options.min_value,
                max: vm.options.max_value,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      })
    },
  },
  methods: {
    /** This chart component has fixed data (data seen as today) and some
     * switchable data (data at X days ago).
     * This method is responsible to load this second bunch of data
     */
    changeOffsetData(newData) {
      //this.chart.update();
    },
    updateData(newData) {
      var etl = new EtlStackedBarData(newData)

      //fuerzo actualizar el tamaño del lienzo
      if (this.chart.height === 0 && this.height > 0) {
        this.chart.canvas.parentNode.style.height = this.height + 'px'
      }
      this.chart.canvas.parentNode.style.width = document.getElementById('reference-width').firstElementChild.offsetWidth - 20 + 'px'
      this.chart.data = etl.process().getData()
      this.chart.update()
    },
  },
  data() {
    return {
      type: 'bar',
    }
  },
  watch: {
    data(newVal, oldVal) {
      this.updateData(newVal)
      this.$emit('wrapper-init', this.id)
    },
  },
}
</script>
